// extracted by mini-css-extract-plugin
export default {"tooltip":"wK-z","arrow":"xK-z"};